import { Link } from "react-router-dom";
import { countByPattern, getPatterns, textureSrc } from "@/lib/catalog";
import { useReducedMotion } from "./motion";

// Faixa fina de tecidos reais, como amostras alinhadas: passa devagar, pára ao pairar e cada uma abre o seu tecido.
function Swatch({ p }) {
  return (
    <Link to={`/tecidos/${p.id}`} data-testid={`marquee-${p.id}`} className="group block w-[84px] shrink-0 sm:w-[104px]" aria-label={`Tecido ${p.name}`}>
      {/* amostra como um retalho: cantos bem redondos e um pesponto tracejado por dentro, como nas peças */}
      <span className="relative block aspect-square overflow-hidden rounded-2xl bg-linen shadow-[0_6px_16px_rgba(64,55,49,.10)] sm:rounded-3xl">
        <span className="block h-full w-full bg-cover bg-center transition-transform duration-[900ms] ease-out group-hover:scale-105" style={{ backgroundImage: `url(${textureSrc(p.texture, 240)})` }} />
      </span>
      <span className="mt-2 block truncate text-center text-[11px] text-taupe-strong">{p.name}</span>
    </Link>
  );
}

export function FabricStrip() {
  const reduced = useReducedMotion();
  const patterns = getPatterns().filter((p) => countByPattern(p.id) > 0);
  if (!patterns.length) return null;
  return (
    <section className="relative z-10 hidden bg-ivory py-9 sm:block sm:py-12" style={{ "--scallop-color": "var(--bb-ivory)" }} data-testid="home-marquee" aria-label="Tecidos disponíveis">
      {/* festões em cima e em baixo, como no rodapé */}
      <span aria-hidden="true" className="bb-scallop-top-edge" />
      <span aria-hidden="true" className="bb-scallop-bottom" />
      <div className="bb-container mb-4 flex items-baseline justify-between gap-4">
        <p className="font-display text-lg text-ink sm:text-xl">{patterns.length} tecidos <span className="text-taupe">para escolher</span></p>
        <Link to="/tecidos" data-testid="marquee-all" className="bb-link bb-tap text-sm font-medium">Ver todos</Link>
      </div>
      {reduced ? (
        <div className="flex gap-3 overflow-x-auto px-5 pb-1 [scrollbar-width:none] sm:px-8 [&::-webkit-scrollbar]:hidden">
          {patterns.map((p) => <Swatch key={p.id} p={p} />)}
        </div>
      ) : (
        <div className="overflow-hidden">
          <div className="bb-marquee flex w-max hover:[animation-play-state:paused]">
            {[0, 1].map((copy) => (
              <div key={copy} className="flex gap-3 pr-3" aria-hidden={copy === 1}>
                {patterns.map((p) => <Swatch key={p.id} p={p} />)}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
